import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Role =
  | 'FAN'
  | 'CLUB_EDITOR'
  | 'CLUB_SHOP_MANAGER'
  | 'CLUB_SUPPORT'
  | 'CLUB_ADMIN'
  | 'SUPER_ADMIN'
  | 'DEVELOPER';

export interface AuthUser {
  id: string;
  email: string;
  displayName?: string;
  role: Role;
  isSuperAdmin: boolean;
  tenantSlug?: string;
}

interface AuthState {
  token: string | null;
  user: AuthUser | null;
  loading: boolean;
  setAuth: (token: string, user: AuthUser) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      loading: false,
      setAuth: (token, user) => set({ token, user, loading: false }),
      logout: () => set({ token: null, user: null, loading: false }),
    }),
    {
      name: 'tc-auth',
      partialize: (state) => ({ token: state.token, user: state.user }),
    },
  ),
);
